// import React, { useEffect, useState } from "react";
// import SideMenu from "../components/SideMenu";
// import UserMenu from "../components/UserMenu";
// import Header from "../components/Header";
// import axios from "axios";
// import API_BASE_URL from "../utilities/ApiConfig";
// import { toast } from "react-toastify";
// import { Box, TableCell } from "@mui/material";
// import MUIDataTable from "mui-datatables";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { useSelector } from "react-redux";
// import fingerPrintServices from "../services/fingerPrintService";
// import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
// import ApiLoader from "../components/ApiLoader";
// import REPORT_BASE_URL, { REPORT_BASE_URLDSC } from "../utilities/ReportConfig";
// import dscpdf from "../components/pdf/dscpdf.txt";
// import DSCSignPopup from "../Modal/DSCSignPopup";

// const DscRegularization = () => {
//   const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);

//   const [loading, setLoading] = useState(false);
//   const [registrationDetails, setRegistrationDetails] = useState([]);
//   const [fingerprintScannerLoading, setFingerprintScannerLoading] =
//     useState(false);
//   const [refresh, setRefresh] = useState(0);

//   // **Pagination state**
//   const [page, setPage] = useState(0); // zero-based for MUI
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);

//   const [openPdfDialog, setOpenPdfDialog] = useState(false);
//   const [dscRawData, setDscRawData] = useState(null);
//   const [dscPde, setDscPde] = useState(null);
//   const [previewed, setPreviewed] = useState(new Set());

//   const fetchRegistrationDetails = async (pageIndex = 0, pageSize = 10) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/DSCMail/GetDscRegularization/${dcode}/${srocode}/ADD`,
//         { params: { page: pageIndex + 1, pageSize } },
//       );
//       if (response.data.statusCode === 200) {
//         setRegistrationDetails(response.data.data);
//         setTotalCount(response.data.totalCount);
//       }
//     } catch {
//       toast.error("Failed to get registration data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Refetch whenever page or pageSize (or refresh) changes
//   useEffect(() => {
//     fetchRegistrationDetails(page, rowsPerPage);
//   }, [page, rowsPerPage, refresh]);

//   const headerCellSx = {
//     textTransform: "uppercase",
//     fontWeight: "semibold",
//     fontFamily: "Poppins",
//     backgroundColor: "#CACACA",
//     color: "#000",
//     borderBottom: "2px solid #ECECEC",
//     fontSize: "0.875rem",
//   };

//   const columns = [
//     // ... your existing column definitions untouched ...
//     {
//       name: "book",
//       label: "Book",
//       options: {
//         filter: false,
//         sort: true,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (val) => (
//           <div className="text-center text-xs md:text-sm">{val}</div>
//         ),
//       },
//     },
//     {
//       name: "regYear",
//       label: "Registration Year",
//       options: {
//         filter: false,
//         sort: true,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (val) => (
//           <div className="text-center text-xs md:text-sm">{val}</div>
//         ),
//       },
//     },
//     {
//       name: "regNo",
//       label: "Registration Number",
//       options: {
//         filter: false,
//         sort: true,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (val) => (
//           <div className="text-center text-xs md:text-sm">{val}</div>
//         ),
//       },
//     },
//     {
//       name: "deed",
//       label: "Deed",
//       options: {
//         filter: false,
//         sort: true,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (val) => (
//           <div className="text-center text-xs md:text-sm">{val}</div>
//         ),
//       },
//     },
//     {
//       name: "subDeed",
//       label: "Sub Deed",
//       options: {
//         filter: false,
//         sort: true,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (val) => (
//           <div className="text-center text-xs md:text-sm">{val}</div>
//         ),
//       },
//     },
//     {
//       name: "Preview Deed",
//       label: "Preview Deed",
//       options: {
//         filter: false,
//         sort: false,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (_, meta) => {
//           const regno = meta.rowData[2];
//           return (
//             <button
//               onClick={() => handleDeed(regno)}
//               className="w-full bg-blue-400 text-white text-sm px-2 py-1 rounded hover:bg-blue-700"
//             >
//               Preview Deed
//             </button>
//           );
//         },
//       },
//     },
//     // {
//     //   name: "DSC",
//     //   label: "DSC",
//     //   options: {
//     //     filter: false,
//     //     sort: false,
//     //     customHeadRender: (col) => (
//     //       <TableCell key={col.index} align="center" sx={headerCellSx}>
//     //         {col.label}
//     //       </TableCell>
//     //     ),
//     //     customBodyRender: (_, meta) => {
//     //       const regno = meta.rowData[2];
//     //       return (
//     //         <button
//     //           onClick={() => handleDSC(regno)}
//     //           className="w-full bg-blue-400 text-white text-sm px-2 py-1 rounded hover:bg-blue-700"
//     //         >
//     //           DSC
//     //         </button>
//     //       );
//     //     },
//     //   },
//     // },

//     {
//       name: "DSC",
//       label: "DSC",
//       options: {
//         filter: false,
//         sort: false,
//         customHeadRender: (col) => (
//           <TableCell key={col.index} align="center" sx={headerCellSx}>
//             {col.label}
//           </TableCell>
//         ),
//         customBodyRender: (_, meta) => {
//           const regno = meta.rowData[2];
//           const isPreviewed = previewed.has(regno);
//           return (
//             <button
//               onClick={() => handleDSC(regno)}
//               disabled={!isPreviewed}
//               className={`w-full text-white text-sm px-2 py-1 rounded ${
//                 isPreviewed
//                   ? "bg-blue-400 hover:bg-blue-700"
//                   : "bg-secondary-500 cursor-not-allowed"
//               }`}
//             >
//               DSC
//             </button>
//           );
//         },
//       },
//     },
//   ];

//   const options = {
//     serverSide: true,
//     count: totalCount,
//     page,
//     rowsPerPage,
//     onTableChange: (action, tableState) => {
//       if (action === "changePage") setPage(tableState.page);
//       if (action === "changeRowsPerPage") {
//         setRowsPerPage(tableState.rowsPerPage);
//         setPage(0);
//       }
//     },
//     selectableRows: "none",
//     filterType: "dropdown",
//     elevation: 0,
//     rowsPerPageOptions: [10, 15, 25, 50],
//     responsive: "standard",
//     download: false,
//     print: false,
//     viewColumns: false,
//     search: true,
//     customToolbarSelect: () => null,
//   };

//   const theme = createTheme({
//     typography: { fontFamily: "Poppins" },
//     palette: { background: { paper: "#fff", default: "#fff" }, mode: "light" },
//     components: {
//       MuiTableCell: {
//         styleOverrides: {
//           body: {
//             padding: "3px 4px",
//             borderBottom: "1px solid #ECECEC",
//             textAlign: "center",
//           },
//           footer: { padding: "7px 15px" },
//         },
//       },
//     },
//   });

//   const handleDSC = async (regno) => {
//     const rec = registrationDetails.find((r) => r.regNo === regno);
//     if (!rec) return;
//     setDscPde(rec.userName);
//     try {
//       setLoading(true);
//       debugger;
//       const resp = await axios.get(`${REPORT_BASE_URLDSC}/UploadDoc/CRS_DSC`, {
//         params: {
//           PDE_ID: rec.userName,
//           dcode,
//           srocode,
//           regyear: rec.regYear,
//           bookno: rec.book,
//           regno: rec.regNo,
//           mode: "Post_REGULIZATION",
//         },
//         responseType: "text",
//       });
//       debugger;
//       setDscRawData(resp.data);
//       setOpenPdfDialog(true);
//     } catch {
//       toast.error("Failed to load document for DSC");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleDeed = async (regno) => {
//   //   const rec = registrationDetails.find((r) => r.regNo === regno);
//   //   if (!rec) return;
//   //   // const pde = "UKVPD2025090400004";
//   //   setLoading(true);
//   //   try {
//   //     const resp = await axios.get(
//   //       `${API_BASE_URL}/DSCMail/GetBase64PDF?pde_id=${encodeURIComponent(
//   //         rec.userName
//   //       )}`
//   //       // `${API_BASE_URL}/DSCMail/GetBase64PDF?pde_id=${encodeURIComponent(pde)}`
//   //     );
//   //     debugger;
//   //     const base64 = resp.data.base64;

//   //     // 3) decode + open
//   //     const binary = atob(base64);
//   //     const len = binary.length;
//   //     const bytes = new Uint8Array(len);
//   //     for (let i = 0; i < len; i++) {
//   //       bytes[i] = binary.charCodeAt(i);
//   //     }
//   //     const blob = new Blob([bytes], { type: "application/pdf" });
//   //     const url = URL.createObjectURL(blob);
//   //     window.open(url, "_blank");

//   //     // **mark this regno as previewed**
//   //     setPreviewed((prev) => {
//   //       const next = new Set(prev);
//   //       next.add(regno);
//   //       return next;
//   //     });
//   //   } catch (err) {
//   //     toast.error(`Failed to load document for Deed: ${err.message}`);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleDeed = async (regno) => {
//     const rec = registrationDetails.find((r) => r.regNo === regno);
//     if (!rec) return;

//     setLoading(true);

//     try {
//       const resp = await axios.get(`${REPORT_BASE_URLDSC}/UploadDoc/CRS_DSC`, {
//         params: {
//           PDE_ID: rec.userName,
//           dcode,
//           srocode,
//           regyear: rec.regYear,
//           bookno: rec.book,
//           regno: rec.regNo,
//           mode: "Post_REGULIZATION",
//         },
//         responseType: "text",
//       });

//       let raw = resp.data;

//       // 1) Remove everything after the PDF base64 end
//       const cleaned = raw.split("<!DOCTYPE")[0].trim();

//       // cleaned now contains pure base64 string
//       const base64 = cleaned;

//       // 2) Convert base64 to PDF blob
//       const binary = atob(base64);
//       const len = binary.length;
//       const bytes = new Uint8Array(len);
//       for (let i = 0; i < len; i++) {
//         bytes[i] = binary.charCodeAt(i);
//       }

//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       window.open(url, "_blank");

//       // mark previewed
//       setPreviewed((prev) => {
//         const next = new Set(prev);
//         next.add(regno);
//         return next;
//       });
//     } catch (err) {
//       console.error(err);
//       toast.error(`Failed to load document: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {loading && <ApiLoader />}
//       {fingerprintScannerLoading && <FingerprintScannerLoader />}
//       <div className="flex h-screen">
//         <SideMenu />
//         <div className="flex-1 flex flex-col">
//           <Header />
//           <div className="flex flex-1">
//             {/* Left Side */}
//             <div className="flex-1 align-middle justify-center h-full overflow-auto">
//               <div className="py-5 flex justify-center items-center">
//                 <Box width="100%">
//                   <ThemeProvider theme={theme}>
//                     <MUIDataTable
//                       title={"DSC"}
//                       data={registrationDetails}
//                       columns={columns}
//                       options={options}
//                     />
//                   </ThemeProvider>
//                 </Box>
//               </div>
//             </div>
//             {/* Right Side */}
//             <div className="w-52 3xl:w-64 h-full">
//               <UserMenu />
//             </div>
//           </div>
//         </div>
//         <DSCSignPopup
//           open={openPdfDialog}
//           onClose={() => setOpenPdfDialog(false)}
//           pde={dscPde}
//           initialDataToSign={dscRawData}
//         />
//       </div>
//     </>
//   );
// };

// export default DscRegularization;

// src/pages/DscRegularization.jsx
import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import UserMenu from "../components/UserMenu";
import Header from "../components/Header";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import { Box, TableCell } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
import ApiLoader from "../components/ApiLoader";
import { REPORT_BASE_URLDSC } from "../utilities/ReportConfig";
import DSCSignPopup from "../Modal/DSCSignPopup";

const DscRegularization = () => {
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);

  const [loading, setLoading] = useState(false);
  const [registrationDetails, setRegistrationDetails] = useState([]);
  const [fingerprintScannerLoading, setFingerprintScannerLoading] =
    useState(false);
  const [refresh, setRefresh] = useState(0);

  // Pagination
  const [page, setPage] = useState(0); // zero-based for MUI
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // DSC Popup
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [dscRawData, setDscRawData] = useState(null);
  const [dscPde, setDscPde] = useState(null);

  // Gate DSC button until preview
  const [previewed, setPreviewed] = useState(new Set());

  const fetchRegistrationDetails = async (pageIndex = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/DSCMail/GetDscRegularization/${dcode}/${srocode}/ADD`,
        { params: { page: pageIndex + 1, pageSize } },
      );

      if (response.data.statusCode === 200) {
        setRegistrationDetails(response.data.data || []);
        setTotalCount(response.data.totalCount || 0);
      } else {
        toast.error("Failed to get registration data");
      }
    } catch (e) {
      toast.error("Failed to get registration data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrationDetails(page, rowsPerPage);
  }, [page, rowsPerPage, refresh]);

  const headerCellSx = {
    textTransform: "uppercase",
    fontWeight: "semibold",
    fontFamily: "Poppins",
    backgroundColor: "#CACACA",
    color: "#000",
    borderBottom: "2px solid #ECECEC",
    fontSize: "0.875rem",
  };

  const markPreviewed = (regno) => {
    setPreviewed((prev) => {
      const next = new Set(prev);
      next.add(regno);
      return next;
    });
  };

  // ✅ Preview deed (you already call CRS_DSC and extract base64)
  const handleDeed = async (regno) => {
    const rec = registrationDetails.find((r) => r.regNo === regno);
    if (!rec) return;

    setLoading(true);
    try {
      const resp = await axios.get(`${REPORT_BASE_URLDSC}/UploadDoc/CRS_DSC`, {
        params: {
          PDE_ID: rec.userName,
          dcode,
          srocode,
          regyear: rec.regYear,
          bookno: rec.book,
          regno: rec.regNo,
          mode: "Post_REGULIZATION",
        },
        responseType: "text",
      });

      const raw = resp.data || "";
      const cleaned = raw.split("<!DOCTYPE")[0].trim(); // remove HTML if appended
      const base64 = cleaned;

      // base64 -> blob -> open
      const binary = atob(base64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      markPreviewed(regno);
    } catch (err) {
      console.error(err);
      toast.error(`Failed to load document: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Existing DSC flow (emBridge popup)
  const handleDSC = async (regno) => {
    const rec = registrationDetails.find((r) => r.regNo === regno);
    if (!rec) return;

    setDscPde(rec.userName);

    try {
      setLoading(true);

      const resp = await axios.get(`${REPORT_BASE_URLDSC}/UploadDoc/CRS_DSC`, {
        params: {
          PDE_ID: rec.userName,
          dcode,
          srocode,
          regyear: rec.regYear,
          bookno: rec.book,
          regno: rec.regNo,
          mode: "Post_REGULIZATION",
        },
        responseType: "text",
      });

      setDscRawData(resp.data);
      setOpenPdfDialog(true);
    } catch {
      toast.error("Failed to load document for DSC");
    } finally {
      setLoading(false);
    }
  };

  // ✅ NEW: Manual upload flow (signed PDF already done by user)
  const handleManualUpload = async (regno) => {
    const rec = registrationDetails.find((r) => r.regNo === regno);
    if (!rec) return;

    // pick file without adding UI
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/pdf";

    input.onchange = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      try {
        setLoading(true);

        const fd = new FormData();
        fd.append("File", file);

        // keep file naming consistent in server (optional)
        fd.append("FileName", `${rec.userName}.pdf`);

        // optional trace/reference for logs
        fd.append(
          "RefNo",
          `${dcode}-${srocode}-${rec.regYear}-${rec.book}-${rec.regNo}`,
        );

        const resp = await axios.post(
          `${API_BASE_URL}/DSCMail/UploadManualSignedDoc`,
          fd,
          { headers: { "Content-Type": "multipart/form-data" } },
        );

        const data = resp.data;

        if (data?.success) {
          if (data.emailSent) {
            toast.success("✅ Signed PDF uploaded, saved & emailed!");
          } else {
            toast.warning(
              "✅ Signed PDF uploaded & saved. Email pending (SMTP issue).",
            );
          }
          setRefresh((r) => r + 1);
        } else {
          toast.error("Manual upload failed.");
        }
      } catch (err) {
        console.error(err);
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Failed to upload signed PDF",
        );
      } finally {
        setLoading(false);
      }
    };

    input.click();
  };

  const columns = [
    {
      name: "book",
      label: "Book",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (val) => (
          <div className="text-center text-xs md:text-sm">{val}</div>
        ),
      },
    },
    {
      name: "regYear",
      label: "Registration Year",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (val) => (
          <div className="text-center text-xs md:text-sm">{val}</div>
        ),
      },
    },
    {
      name: "regNo",
      label: "Registration Number",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (val) => (
          <div className="text-center text-xs md:text-sm">{val}</div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (val) => (
          <div className="text-center text-xs md:text-sm">{val}</div>
        ),
      },
    },
    {
      name: "subDeed",
      label: "Sub Deed",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (val) => (
          <div className="text-center text-xs md:text-sm">{val}</div>
        ),
      },
    },
    {
      name: "Preview Deed",
      label: "Preview Deed",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (_, meta) => {
          const regno = meta.rowData[2];
          return (
            <button
              onClick={() => handleDeed(regno)}
              className="w-full bg-blue-400 text-white text-sm px-2 py-1 rounded hover:bg-blue-700"
            >
              Preview Deed
            </button>
          );
        },
      },
    },
    // {
    //   name: "DSC",
    //   label: "DSC",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customHeadRender: (col) => (
    //       <TableCell key={col.index} align="center" sx={headerCellSx}>
    //         {col.label}
    //       </TableCell>
    //     ),
    //     customBodyRender: (_, meta) => {
    //       const regno = meta.rowData[2];
    //       const isPreviewed = previewed.has(regno);
    //       return (
    //         <button
    //           onClick={() => handleDSC(regno)}
    //           disabled={!isPreviewed}
    //           className={`w-full text-white text-sm px-2 py-1 rounded ${
    //             isPreviewed
    //               ? "bg-blue-400 hover:bg-blue-700"
    //               : "bg-secondary-500 cursor-not-allowed"
    //           }`}
    //         >
    //           DSC
    //         </button>
    //       );
    //     },
    //   },
    // },
    // ✅ NEW COLUMN: Manual Upload (uses new API)
    {
      name: "ManualUpload",
      label: "Upload Signed",
      options: {
        filter: false,
        sort: false,
        // customHeadRender: (col) => (
        //   <TableCell key={col.index} align="center" sx={headerCellSx}>
        //     {col.label}
        //   </TableCell>
        // ),
        // customBodyRender: (_, meta) => {
        //   const regno = meta.rowData[2];
        //   const isPreviewed = previewed.has(regno);
        //   return (
        //     <button
        //       onClick={() => handleManualUpload(regno)}
        //       disabled={!isPreviewed}
        //       className={`w-full text-white text-sm px-2 py-1 rounded ${
        //         isPreviewed
        //           ? "bg-green-600 hover:bg-green-700"
        //           : "bg-secondary-500 cursor-not-allowed"
        //       }`}
        //       title="Manually sign PDF, then upload signed PDF"
        //     >
        //       Upload Signed
        //     </button>
        //   );
        // },
        customHeadRender: (col) => (
          <TableCell key={col.index} align="center" sx={headerCellSx}>
            {col.label}
          </TableCell>
        ),
        customBodyRender: (_, meta) => {
          const regno = meta.rowData[2];
          return (
            <button
              onClick={() => handleManualUpload(regno)}
              className="w-full bg-blue-400 text-white text-sm px-2 py-1 rounded hover:bg-blue-700"
            >
              Upload Signed
            </button>
          );
        },
      },
    },
  ];

  const options = {
    serverSide: true,
    count: totalCount,
    page,
    rowsPerPage,
    onTableChange: (action, tableState) => {
      if (action === "changePage") setPage(tableState.page);
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    download: false,
    print: false,
    viewColumns: false,
    search: true,
    customToolbarSelect: () => null,
  };

  const theme = createTheme({
    typography: { fontFamily: "Poppins" },
    palette: { background: { paper: "#fff", default: "#fff" }, mode: "light" },
    components: {
      MuiTableCell: {
        styleOverrides: {
          body: {
            padding: "3px 4px",
            borderBottom: "1px solid #ECECEC",
            textAlign: "center",
          },
          footer: { padding: "7px 15px" },
        },
      },
    },
  });

  return (
    <>
      {loading && <ApiLoader />}
      {fingerprintScannerLoading && <FingerprintScannerLoader />}

      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            <div className="flex-1 align-middle justify-center h-full overflow-auto">
              <div className="py-5 flex justify-center items-center">
                <Box width="100%">
                  <ThemeProvider theme={theme}>
                    <MUIDataTable
                      title={"DSC"}
                      data={registrationDetails}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div>

            <div className="w-52 3xl:w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>

        {/* Existing popup stays exactly same for future DSC renewal */}
        <DSCSignPopup
          open={openPdfDialog}
          onClose={() => setOpenPdfDialog(false)}
          pde={dscPde}
          initialDataToSign={dscRawData}
        />
      </div>
    </>
  );
};

export default DscRegularization;
